import { useEffect, useState } from 'react';
import { MapPinned, Truck } from 'lucide-react';
import { outbox } from '../../offline/index.js';

// The van tracker's question for the team (api jobs/autoSteps.js): its van
// set off / stopped at a job, so "On route to …?" / "Arrived at …?". Yes marks
// it at the time the van did it; Not yet leaves it. With no answer it's
// marked anyway at markAt (5 minutes after asking). Answers go through the
// outbox, so they work with no signal. prompt: the schedule's `prompt`.
const hhmm = (d) => new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit' }).format(new Date(d));

export default function VanPrompt({ prompt }) {
  const [answered, setAnswered] = useState(null); // the prompt id answered on this phone
  const [, tick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => tick((n) => n + 1), 15_000);
    return () => clearInterval(t);
  }, []);
  if (!prompt || answered === prompt.id) return null;
  const arrive = prompt.step === 'arrive';
  const left = Math.max(0, Math.ceil((new Date(prompt.markAt) - Date.now()) / 60_000));
  const answer = async (ok) => {
    setAnswered(prompt.id);
    await outbox.enqueue('job.auto.answer', { promptId: prompt.id, ok });
  };
  return (
    <section className="card van-prompt" role="alert">
      <p className="van-prompt-q">
        {arrive ? <MapPinned size={20} aria-hidden="true" /> : <Truck size={20} aria-hidden="true" />}
        <strong>{arrive ? `Arrived at ${prompt.address}?` : `On route to ${prompt.address}?`}</strong>
      </p>
      <p className="small">
        {arrive ? 'Your van stopped there' : 'Your van set off'} at {hhmm(prompt.detectedAt)}.
        {' '}{left ? `If you don’t answer, it’s marked ${arrive ? 'Arrived' : 'On route'} in ${left} minute${left === 1 ? '' : 's'}.` : `It’s being marked ${arrive ? 'Arrived' : 'On route'} now.`}
      </p>
      <div className="actions">
        <button type="button" className="btn primary" onClick={() => answer(true)}>{arrive ? 'Yes, arrived' : 'Yes, on route'}</button>
        <button type="button" className="btn" onClick={() => answer(false)}>Not yet</button>
      </div>
    </section>
  );
}
